import { getQueryParams } from './connectivity/request'

// Construct dictionnary
const dictionnary: Record<string, any> = {
  mobile: {
    en: {
      title: 'Best Cell Phone Plans in Canada - Find the Cheapest Prices - PlanHub',
      'og:title': 'Best Cell Phone Plans in Canada - Find the Cheapest Prices',
      'og:description':
        'PlanHub helps you find the cheapest cell phone plans in Canada. Compare prices, deals & promotions from Bell, Telus, Rogers, Fizz, Fido, Virgin, Koodo, Public Mobile, Chatr & more.',
      'twitter:title': 'Best Cell Phone Plans in Canada - Find the Cheapest Prices',
      'twitter:description':
        'PlanHub helps you find the cheapest cell phone plans in Canada. Compare prices, deals & promotions from Bell, Telus, Rogers, Fizz, Fido, Virgin, Koodo, Public Mobile, Chatr & more.',
    },
    fr: {
      title: 'Forfaits cellulaires - Comparer les meilleurs forfaits mobile - PlanHub',
      'og:title': 'Forfaits cellulaires - Comparer les meilleurs forfaits mobile',
      'og:description':
        'PlanHub vous aide à trouver le forfait mobile adapté à vos besoins. Comparez les prix & promotions de Bell, Telus, Rogers, Fizz, Fido, Virgin, Koodo, Public, Chatr, etc.',
      'twitter:title': 'Forfaits cellulaires - Comparer les meilleurs forfaits mobile',
      'twitter:description':
        'PlanHub vous aide à trouver le forfait mobile adapté à vos besoins. Comparez les prix & promotions de Bell, Telus, Rogers, Fizz, Fido, Virgin, Koodo, Public, Chatr, etc.',
    },
  },
  internet: {
    en: {
      title: 'Cheap Internet Plans: Compare Prices of 159 Providers from $17 - PlanHub',
      'og:title': 'Cheap Internet Plans: Compare Prices of 159 Providers from $17',
      'og:description':
        'Find cheap home internet plans in Canada from $17/month with PlanHub. Compare prices, deals & promotions of 159 providers.',
      'twitter:title': 'Cheap Internet Plans: Compare Prices of 159 Providers from $17',
      'twitter:description':
        'Find cheap home internet plans in Canada from $17/month with PlanHub. Compare prices, deals & promotions of 159 providers.',
    },
    fr: {
      title: 'Forfaits Internet: Comparez les prix de 159 opérateurs dès $17 - PlanHub',
      'og:title': 'Forfaits Internet: Comparez les prix de 159 opérateurs dès $17',
      'og:description':
        'Trouvez des forfaits internet résidentiels pas chers au Canada à partir de $17/mois avec PlanHub. Comparez les prix et promotions de plus de 159 fournisseurs.',
      'twitter:title': 'Forfaits Internet: Comparez les prix de 159 opérateurs dès $17',
      'twitter:description':
        'Trouvez des forfaits internet résidentiels pas chers au Canada à partir de $17/mois avec PlanHub. Comparez les prix et promotions de plus de 159 fournisseurs.',
    },
  },
}

export const translateMeta = () => {
  translateDOM()
}

const translateDOM = () => {
  const elementsProperty = document.querySelectorAll('[property="og:title"], [property="og:description"]')
  const elementsName = document.querySelectorAll('[name="twitter:title"], [name="twitter:description"]')
  const elName = document.querySelector('title[eo-translator]')
  elementsProperty.forEach((el: Element) => translateAttribute(el, 'property'))
  elementsName.forEach((el) => translateAttribute(el, 'name'))
  elName!.innerHTML = translate(elName!.getAttribute('eo-translator')!)
}

const translateAttribute = (DOMElement: Element, attribute: string) => {
  if (DOMElement) {
    const injectableElementText = DOMElement.getAttribute(attribute)!
    const translation = translate(injectableElementText)
    DOMElement.setAttribute('content', translation)
  }
}

const translate = (input = '') => {
  const queryString = window.location.search
  const language = (getQueryParams().locale as string) || 'en'
  const type = queryString.indexOf('internet')
  const displayType = type > -1 ? 'internet' : 'mobile'
  const params = {}

  if (dictionnary.hasOwnProperty(displayType)) {
    return assignParams(dictionnary[displayType][language][input], params)
  }

  return input
}

const assignParams = (raw: string, params: Record<string, any>) => {
  Object.keys(params).forEach((key) => {
    const pattern = new RegExp(`{${key}}`, 'g')
    raw = raw.replace(pattern, params[key])
  })
  return raw
}
